import React from 'react';

import { useProduct } from '../../hooks/useProduct'
import * as constants from '../../constants'
import AbstractBestPracticeList from '../AbstractBestPracticeList'


export default function(props) {
  const productDetails = useProduct()
  return (
    <AbstractBestPracticeList
      category={constants.CATEGORY_INTRODUCE_BUGS}
      title={'Python bug detection'}
      seoTitle={'Python bug detection'}
      svgPath='/risk.svg'
      synopsis_parageaph_one={`${productDetails.name} suggests fixes if your code appears to introduce a bug, or if it looks like the code is not doing what your intended.`}
      synopsis_parageaph_two={`This gives you another line of defense against human error because if one human can commit a bug then another human certainly can miss it during code review.`}
    />
  );
}
